{
    "NextrunningatLabel": "Próxima Execução em:",
    "LastrunatLabel": "Última execução em:",
    "StatuserrorLabel": "Situação\/Erro:",
    "ScheduleStatus_SectionHeader": "Status de agendamento",
    "NAME": "ScheduleStatus"
}